import { render, staticRenderFns } from "./PCardList.vue?vue&type=template&id=4484e174&"
import script from "./PCardList.vue?vue&type=script&lang=ts&"
export * from "./PCardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports